/** @jsxImportSource @emotion/react */
import PageDebate from "../../components/debate/pageMapingDebate/PageDebate";

const HotDebatePage = () => {
  return (
    <>
      <PageDebate 
        pathMov={"hotDiscusstion"}
        postId={-1}
       />
    </>
  );
};


export default HotDebatePage;
